import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "w-full mt-4 px-4 overflow-y-auto overflow-x-scroll",
  style: {"grid-area":"table","min-width":"1200px"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden md:grid lg:grid-cols-12 md:grid-cols-6 gap-2 w-full items-center py-2 border-b font-semibold text-gray-700 text-xs md:text-sm\"><div class=\"lg:col-span-2 md:col-span-2\"><p class=\"text-left\">ID</p></div><div class=\"lg:col-span-3 md:col-span-4\"><p class=\"truncate text-left\">Nome da Política</p></div><div class=\"lg:col-span-2 md:col-span-3\"><p class=\"text-left\">Empresa</p></div><div class=\"lg:col-span-2 md:col-span-3\"><p class=\"text-left\">Criado por</p></div><div class=\"col-span-12 md:col-span-6 lg:col-span-3 flex flex-row lg:justify-start justify-center items-center lg:gap-4 gap-12 mt-4 md:mt-0\"><p class=\"text-left\">Ações</p></div><div class=\"lg:col-span-1 md:col-span-2\"></div><div class=\"lg:col-span-1 md:col-span-2\"></div></div>", 1)

import TableDsPolicies from '@/components/designSystem/Table/TableDsPolicies.vue'
import { DsPolicyItem } from '@/Network/Types/Responses/DsPolicyResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'ds.policies.tab',
  props: {
    policies: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.policies, (policy) => {
      return (_openBlock(), _createBlock(TableDsPolicies, {
        key: policy.id,
        data: {
        ...policy
      }
      }, null, 8, ["data"]))
    }), 128))
  ]))
}
}

})